import React, {Component} from "react";
import {Redirect} from "react-router-dom";

class LegacyRouter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            to: "",
            id: ""
        }
    }

    componentDidMount() {
        if (this.props.location.pathname.startsWith("/semaphores/")) {
            let id = this.props.location.pathname.slice(12, -5);
            this.setState({to: 'semaphore', id});
        } else {
            let id = this.props.location.pathname.slice(1, -5);
            fetch('/isOrganization?id=' + id)
                .then(response => response.json())
                .then(data => {
                    this.setState({id, to: data.isOrganization ? "organization" : "operation"});
                });
        }
    }

    render() {
        let {to, id} = this.state;
        if (to === "") return <div></div>;
        else return <Redirect to={"/" + to + "/" + id}/>;
    }
}

export default LegacyRouter;
